import * as Yup from 'yup';
import { licenseFile } from './utilities';

export const validationFormStepTwo = (props) =>
	Yup.object().shape({
		dealerLicenseFile: licenseFile(props.t),
		driverLicenseFile: licenseFile(props.t),
	});
